import { useTheme } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DetailList } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { FaSearchLocation } from 'react-icons/fa';
import { ICON_NAME } from './constants';
import type { DetaiListProPracticalProps, DetailListProPracticalItemType } from './types';

export * from './types';

export const DetailListProPractical: FC<DetaiListProPracticalProps> = (props) => {
  const { items, proType, ...rest } = props;
  const { translate } = useTranslation();
  const theme = useTheme();
  return (
    <DetailList
      {...rest}
      items={Object.keys(items).map((itemKey) => {
        let label = translate(`glossary.${itemKey}`);
        if (itemKey === 'employeeNumbers' && proType) {
          label = translate(`glossary.employeeNumbers.${proType.toLowerCase()}`);
        }
        return {
          label,
          value: items[itemKey as keyof typeof items],
          labelIcon:
            itemKey === 'practicePlaces' ? (
              <FaSearchLocation fill={theme.color.blue.default} />
            ) : (
              <FontAwesomeIcon icon={ICON_NAME[itemKey as DetailListProPracticalItemType]} />
            ),
        };
      })}
    />
  );
};
